import { Box, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { Clear, Edit, Info, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogEdit from "./modal/dialogEdit";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import messages from "../../../utils/messages";
import serviceConcessionaria from "../../../services/serviceConcessionaria";
import serviceInstalacao from "../../../services/serviceInstalacao";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const ClienteInstalacao = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Cadastro - Instalações");
    }, [setTitlePage]);

    const history = useHistory();

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [editState, setEditState] = useState({
        open: false,
        id: "",
        numeroInstalacao: "",
        tipoInstalacao: "",
        tipoClasseInstalacao: "",
        classeInstalacao: "",
        concessionariaID: "",
    });

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);

    const tipoInstalacaoOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Usina", value: "Usina" },
        { label: "Cliente", value: "Cliente" },
    ];

    const tipoClasseInstalacao = [
        { label: "Todos", value: "Todos" },
        { label: "Comercial", value: "Comercial" },
        { label: "Residencial", value: "Residencial" },
        { label: "Rural", value: "Rural" },
        { label: "Poder Público", value: "Poder Público" },
    ];

    const classeInstalacaoOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Monofásico", value: "Monofásico" },
        { label: "Bifásico", value: "Bifásico" },
        { label: "Trifásico", value: "Trifásico" },
    ];

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            instalacaoID: "", //Vem por parâmetro quando tela acionada por outra tela
            numeroInstalacao: "",
            flagAtivo: "",
            tipoInstalacao: "Cliente",
            tipoClasseInstalacao: "",
            classeInstalacao: "",
            ConcessionariaID: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 160,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Informações">
                                <Info />
                            </Tooltip>
                        }
                        label="Informações"
                        onClick={() => onClickInfo(params.row.numeroInstalacao)}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                numeroInstalacao: params.row.numeroInstalacao,
                                tipoInstalacao: params.row.tipoInstalacao,
                                tipoClasseInstalacao: params.row.tipoClasseInstalacao,
                                classeInstalacao: params.row.classeInstalacao,
                                concessionariaID: params.row.concessionariaID,
                            })
                        }
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "instalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "UC Energisa",
                field: "ucEnergisa",
                type: "string",
                headerAlign: "left",
                width: 150,
            },
            {
                headerName: "Concessionaria",
                field: "nomeConcessionaria",
                type: "string",
                width: 150,
            },
            {
                headerName: "Habilitado",
                field: "flagAtivo",
                type: "string",
                width: 150,
            },
            {
                headerName: "Tipo instalação",
                field: "tipoInstalacao",
                type: "string",
                width: 150,
            },
            {
                headerName: "Tipo classe",
                field: "tipoClasseInstalacao",
                type: "string",
                width: 150,
            },
            {
                headerName: "Classe",
                field: "classeInstalacao",
                type: "string",
                width: 150,
            },
            {
                headerName: "SubClasse",
                field: "subClasseInstalacao",
                type: "string",
                width: 150,
            },
            {
                headerName: "Modalidade",
                field: "modalidadeTarifaria",
                type: "string",
                width: 170,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const flagHabilitadoOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },
    ];

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        if (!filters) {
            filters = { tipoInstalacao: "Cliente" };
        }

        serviceInstalacao
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            if (props && props.location && props.location.state) {
                getAllWithFilters(props.location.state);
            } else {
                getAllWithFilters(filters);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            flagAtivo: values.flagAtivo === "Todos" ? "" : values.flagAtivo,
            tipoInstalacao: values.tipoInstalacao === "Todos" ? "" : values.tipoInstalacao,
            tipoClasseInstalacao: values.tipoClasseInstalacao === "Todos" ? "" : values.tipoClasseInstalacao,
            classeInstalacao: values.classeInstalacao === "Todos" ? "" : values.classeInstalacao,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
        }
    }, [props]);

    const onClickInfo = (numeroInstalacao: any) => {
        history.push({
            pathname: "/faturamento/faturaconcessionaria",
            state: { numeroInstalacao: numeroInstalacao },
        });
    };

    const onClear = () => {
        reset({ instalacaoID: "" });
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container columnSpacing={2}>
                                <Grid item md={10}>
                                    <Grid container columnSpacing={3}>
                                        <Grid item md={3}>
                                            <InputNumber
                                                name="numeroInstalacao"
                                                label="Instalação"
                                                control={control}
                                                error={errors}
                                                decimalScale={0}
                                                noThousandSeparator
                                                maxLength={15}
                                            />
                                        </Grid>

                                        <Grid item md={3}>
                                            <AutoComplete
                                                name="ConcessionariaID"
                                                label="Concessionaria"
                                                options={concessionariaDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={6}>
                                            <AutoComplete
                                                name="flagAtivo"
                                                label="Habilitado"
                                                options={flagHabilitadoOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <AutoComplete
                                                name="tipoInstalacao"
                                                label="Tipo instalação"
                                                options={tipoInstalacaoOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <AutoComplete
                                                name="tipoClasseInstalacao"
                                                label="Tipo classe"
                                                options={tipoClasseInstalacao}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <AutoComplete
                                                name="classeInstalacao"
                                                label="Classe"
                                                options={classeInstalacaoOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={2} sx={{ mt: "20px" }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={12}>
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                                fullWidth
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.instalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            numeroInstalacao: editState.numeroInstalacao,
                            tipoInstalacao: editState.tipoInstalacao,
                            tipoClasseInstalacao: editState.tipoClasseInstalacao,
                            classeInstalacao: editState.classeInstalacao,
                            concessionariaID: editState.concessionariaID,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                numeroInstalacao: "",
                                tipoInstalacao: "",
                                tipoClasseInstalacao: "",
                                classeInstalacao: "",
                                concessionariaID: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default ClienteInstalacao;
